import {
  ApplicationRef,
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  Injector,
  Input,
  OnInit,
} from '@angular/core';

import { ImgPreviewComponent } from '../components/img-preview/img-preview.component';
import { BasicFile } from '../models/basic-file.model';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'img[preview]',
  standalone: false
})

export class ImgPreviewDirective implements OnInit {

  @Input() public preview: string;

  constructor(
    private element: ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
  ) { }

  public ngOnInit() {
    const imgElement: HTMLElement = this.element.nativeElement;
    const childElement = this.createChildElement(imgElement);

    imgElement.parentElement.style.position = 'relative';
    imgElement.parentNode.appendChild(childElement);
  }

  public createChildElement(imgElement: HTMLElement): HTMLElement {
    const childElement = document.createElement('div');
    const childTop = imgElement.parentElement.getBoundingClientRect().top - imgElement.getBoundingClientRect().top;
    const childLeft = imgElement.parentElement.getBoundingClientRect().left - imgElement.getBoundingClientRect().left;
    childElement.style.top = (childTop - 1) + 'px';
    childElement.style.left = (childLeft - 1) + 'px';
    childElement.style.position = 'absolute';
    childElement.style.background = 'transparent';
    childElement.style.cursor = 'pointer';
    childElement.style.width = (imgElement.clientWidth + 2) + 'px';
    childElement.style.height = (imgElement.clientHeight + 2) + 'px';
    childElement.style.zIndex = '1';
    childElement.style.borderRadius = '4px';
    const iconElement = document.createElement('i');
    iconElement.classList.add('fa');
    iconElement.classList.add('fa-eye');
    iconElement.style.position = 'absolute';
    iconElement.style.color = '#fff';
    const iconTop = childTop + imgElement.clientHeight / 2;
    const iconLeft = childLeft + imgElement.clientWidth / 2;
    iconElement.style.top = iconTop + 'px';
    iconElement.style.left = iconLeft + 'px';
    iconElement.style.transform = 'translate(-50%,-50%)';
    iconElement.style.fontSize = '20px';
    iconElement.style.width = '20px';
    iconElement.style.height = '20px';
    iconElement.style.lineHeight = '20px';
    iconElement.style.display = 'none';
    childElement.appendChild(iconElement);

    this.setEventListeners(imgElement, childElement, iconElement);

    return childElement;
  }

  public setEventListeners(imgElement: HTMLElement, childElement: HTMLElement, iconElement: HTMLElement) {

    childElement.addEventListener('mouseenter', () => {
      iconElement.style.display = 'block';
      childElement.style.backgroundColor = 'rgba(0,0,0,.62)';
    }, false);

    childElement.addEventListener('mouseleave', () => {
      iconElement.style.display = 'none';
      childElement.style.backgroundColor = 'transparent';
    }, false);

    childElement.addEventListener('click', (ev) => {
      ev.stopPropagation();
      const src = imgElement.attributes.getNamedItem('src').nodeValue;
      const componentRef = this.componentFactoryResolver.resolveComponentFactory(ImgPreviewComponent).create(this.injector);
      componentRef.instance.file = new BasicFile({
        FileName: this.preview ?? null,
        FilePath: src
      });
      componentRef.instance.closed.subscribe(() => {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
      });
      this.applicationRef.attachView(componentRef.hostView);
      const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      document.body.appendChild(domElem);
    });
  }
}
